/*audit mixin: have route to feedAuditEdit */

//actions
import { GET_AUDIT } from "../../store/actions/audit";
import {SET_AUDIT_PENDING} from "../../store/actions/audit";

export const audit = {
  computed: {
    isEdit() {
      return this.$route.meta.singlePage;
    },
    data() {
      return this.$store.getters.auditData(this.name);
    },
    pending() {
      return this.$store.getters.auditPending(this.name);
    },
  },
  methods: {
    editChart() {
      this.$router.push({
        name: 'feedAuditEdit',
        params: {
          chart: this.name
        }
      });
    },
    onSave() {
      this.saveChart = true;
    },
    handleSaved() {
      this.$store.commit(SET_AUDIT_PENDING, {chart: this.name, pending: false});
      this.saveChart = false;
    },
    handleSave() {
      this.$store.commit(SET_AUDIT_PENDING, {chart: this.name, pending: true});
    }
  },
  mounted() {
    this.$store.dispatch(GET_AUDIT, {chart: this.name, thread: this.$route.params.threadId});
  },
};
